"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Toggle_1 = require("./Toggle");
var react_popper_1 = require("react-popper");
var ClickOutHandler = require('react-onclickout');
var KeyHandler = require('react-key-handler').default;
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popover.prototype.render = function () {
        var _a = this.props, target = _a.target, placement = _a.placement, children = _a.children, onToggle = _a.onToggle, isOpen = _a.isOpen;
        return (React.createElement(Toggle_1.Toggle, { on: isOpen, onToggle: onToggle }, function (_a) {
            var on = _a.on, getTogglerProps = _a.getTogglerProps, close = _a.setOff, open = _a.setOn, toggle = _a.toggle;
            return (React.createElement(react_popper_1.Manager, null,
                React.createElement(react_popper_1.Target, null, function (_a) {
                    var targetProps = _a.targetProps;
                    return target({
                        getTargetProps: function (props) {
                            return getTogglerProps(__assign({}, props, { innerRef: targetProps.ref }));
                        },
                        isOpen: on,
                        toggle: toggle,
                        close: close,
                        open: open,
                    });
                }),
                on && (React.createElement(react_popper_1.Popper, { placement: placement },
                    React.createElement(ClickOutHandler, { onClickOut: close },
                        React.createElement(KeyHandler, { keyEventName: "keydown", keyValue: "Escape", onKeyHandle: close }),
                        typeof children === 'function'
                            ? children({
                                isOpen: on,
                                toggle: toggle,
                                close: close,
                                open: open,
                            })
                            : children)))));
        }));
    };
    return Popover;
}(React.Component));
exports.Popover = Popover;
//# sourceMappingURL=Popover.js.map